module.exports = __webpack_public_path__ + "static/img/205.12e5777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/205.jpg
// module id = jFqr
// module chunks = 0